const TableViewIcon = () => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66663 4.7915C1.66663 4.44633 1.94645 4.1665 2.29163 4.1665H17.7083C18.0535 4.1665 18.3333 4.44633 18.3333 4.7915C18.3333 5.13668 18.0535 5.4165 17.7083 5.4165H2.29163C1.94645 5.4165 1.66663 5.13668 1.66663 4.7915ZM1.66663 9.99984C1.66663 9.65466 1.94645 9.37484 2.29163 9.37484H17.7083C18.0535 9.37484 18.3333 9.65466 18.3333 9.99984C18.3333 10.345 18.0535 10.6248 17.7083 10.6248H2.29163C1.94645 10.6248 1.66663 10.345 1.66663 9.99984ZM1.66663 15.2082C1.66663 14.863 1.94645 14.5832 2.29163 14.5832H17.7083C18.0535 14.5832 18.3333 14.863 18.3333 15.2082C18.3333 15.5533 18.0535 15.8332 17.7083 15.8332H2.29163C1.94645 15.8332 1.66663 15.5533 1.66663 15.2082Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default TableViewIcon
